/* 🤖 this file was generated by svg-to-ts */
export const siriusMinus: {
  name: 'minus';
  data: string;
} = {
  name: 'minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Z" fill="currentColor"/></svg>`
};
